// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"febaedc5","389":"1b2b9b14","455":"391ef5c7","857":"920a2a72","977":"ea4e64fb"}[chunkId] + ".chunk.js";
};